/* eslint-disable no-restricted-imports -- @lingui/core imports are allowed in libs/i18n */
import {i18n} from "@lingui/core";

import Log, {Errors} from "@khan/logging";
import {RequestInfo} from "@khan/shared-core";

/**
 * Initialize Lingui, activating it for the current locale and turning on
 * missing translation tracking.
 */
export const linguiInit = () => {
    // Activate Lingui for the current locale.
    i18n.load(RequestInfo.kaLocale, {});
    i18n.activate(RequestInfo.kaLocale);

    // Track missing translations, sending the data to Sentry. This is only
    // fired in production.
    if (process.env.NODE_ENV === "production") {
        i18n.on("missing", (event) => {
            Log.error("Missing translation", Errors.Internal, {
                sentryData: {
                    tags: event,
                },
            });

            // On ZNDs and pre-default deploys, we want to fail loudly
            // so that e2e tests fail.
            // eslint-disable-next-line no-restricted-syntax -- it's difficult to use wonder-blocks-timing here
            if (window.location.hostname.startsWith("prod-")) {
                throw new Error("Missing translation");
            }
        });
    }
};
